"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import _ from "underscore";
function noAuditFlagsMessage() {
  return /* @__PURE__ */ jsx("div", { className: "alert-box--highlight", children: "No Audit Flags Set" });
}
function showAuditFlag(auditFlag) {
  if (auditFlag.customMessage) {
    return /* @__PURE__ */ jsxs("li", { children: [
      auditFlag.label,
      ": ",
      auditFlag.customMessage
    ] });
  } else {
    return /* @__PURE__ */ jsx("li", { children: auditFlag.label });
  }
}
function hasAuditFlags(props) {
  return !_.isEmpty(props.flags);
}
function showAuditFlags(props) {
  return /* @__PURE__ */ jsx("ul", { className: "factor-invoice--audit-flags", children: _.map(props.flags, showAuditFlag) });
}
export default function AuditFlagDisplay(props) {
  return /* @__PURE__ */ jsx("div", { children: hasAuditFlags(props) ? showAuditFlags(props) : noAuditFlagsMessage() });
}
